import { RECEIVE_CLIENT, RECEIVE_CLIENTS } from "../actions/client";
import { RECEIVE_FEED, RECEIVE_FEEDS } from "../actions/feed";

const DEFAULT_STATE = {
  byId: {},
  allIds: []
};

const clients = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RECEIVE_CLIENT: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      const { reports, ...newClient } = action.client;
      const feedIds = reports.map(feed => feed.id);
      // Intentionally using snake_case since the rest of the keys will be too
      newClient.feed_ids = feedIds;

      const newId = newClient.id;
      byId[newId] = newClient;
      if (!allIds.includes(newId)) allIds.push(newId);

      return {
        byId,
        allIds
      };
    }
    case RECEIVE_CLIENTS: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      action.clients.forEach(client => {
        const { reports, ...newClient } = client;
        const feedIds = reports.map(feed => feed.id);
        // Intentionally using snake_case since the rest of the keys will be too
        newClient.feed_ids = feedIds;
        const newId = newClient.id;
        byId[newId] = newClient;
        if (!allIds.includes(newId)) allIds.push(newId);
      });

      return {
        byId,
        allIds
      };
    }
    case RECEIVE_FEED: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      const newFeed = action.feed;
      const client = byId[newFeed.client_id];
      if (client) {
        let feed_ids = client.feed_ids.slice(0);
        if (!feed_ids.includes(newFeed.id)) feed_ids.push(newFeed.id);
        byId[newFeed.client_id] = { ...client, feed_ids };
      }

      return {
        byId,
        allIds
      };
    }
    case RECEIVE_FEEDS: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      action.feeds.forEach(newFeed => {
        const client = byId[newFeed.client_id];
        if (client) {
          let feed_ids = client.feed_ids.slice(0);
          if (!feed_ids.includes(newFeed.id)) feed_ids.push(newFeed.id);
          byId[newFeed.client_id] = { ...client, feed_ids };
        }
      });

      return {
        byId,
        allIds
      };
    }
    default:
      return state;
  }
};

export default clients;
